import {lazy} from 'react';

export const ContactAsync = lazy(() =>
    import('./Contact')
);
